export default __webpack_public_path__ + "static/media/pavel_s.1732bca4.jpg";